(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["navera-share"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('.nv-share__copy') : null;
    if (!button) return;
    const url = button.getAttribute('data-share-url') || location.href;
    const title = button.getAttribute('data-share-title') || document.title;
    const note = button.querySelector('.nv-share__copied');

    if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
      try {
        await navigator.share({ title, url });
        return;
      } catch {
        /* dismissed: fall through to copy */
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      if (note) {
        note.textContent = 'Link copied';
        setTimeout(() => (note.textContent = ''), 2000);
      }
    } catch {
      /* clipboard blocked */
    }
  });
  } catch(e) { console.error(e); }
})();

})();
